import { render, staticRenderFns } from "./pill.vue?vue&type=template&id=5055dce8&scoped=true"
import script from "./pill.vue?vue&type=script&lang=js"
export * from "./pill.vue?vue&type=script&lang=js"
import style0 from "./pill.vue?vue&type=style&index=0&id=5055dce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5055dce8",
  null
  
)

export default component.exports